import { QueryFilterModel } from './visio-basket.model';

export enum ActionTypes {
  CHANGE_QUERY_FILTER = '[Basket visio] change query filter',
  RESET_QUERY_FILTER = '[Basket visio] reset query filter',
}

export class ChangeQueryFilter {
  readonly type = ActionTypes.CHANGE_QUERY_FILTER;

  constructor(public readonly filters: Partial<QueryFilterModel>) {}
}

export class ResetQueryFilter {
  readonly type = ActionTypes.RESET_QUERY_FILTER;
}

export type ActionsUnion = ChangeQueryFilter | ResetQueryFilter;
